import Prop from "../prop/prop";
import Vue from "vue";

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector("#property");
  const data = el.dataset;

  new Vue({
    el,
    render(h){
      return h(Prop, {
        props: {
          images: JSON.parse(data.images),
          property: JSON.parse(data.property),
          availableDates: JSON.parse(data.availableDates),
          availableDatesWithPrices: JSON.parse(data.availableDatesWithPrices),
          trackingProfileId: data.trackingProfileId,
          visitorEmailId: data.visitorEmailId,
          livePriceUrl: data.livePriceUrl,
          searchId: data.searchId,
          nights: data.nights,
          checkIn: data.checkIn,
          serviceTag: data.serviceTag,
          previousUrl: data.previousUrl,
          growlUrl: data.growl,
          owner: data.owner === "true",
          similarProps: JSON.parse(data.similarProps),
          breadcrumbItems: JSON.parse(data.breadcrumbItems),
          reviews: JSON.parse(data.reviews),
          crumb: JSON.parse(data.crumb),
          favStatus: data.favStatus,
          favUrl: data.favUrl,
          pois: JSON.parse(data.pois),
          tags: JSON.parse(data.tags),
          firstBitOfBody: data.firstBitOfBody,
          secondBitOfBody: data.secondBitOfBody,
          headingCaption: data.headingCaption,
          features: data.features,
          floorplan: JSON.parse(data.floorplan),
          tagItems: JSON.parse(data.tagItems),
          petsGoFree: data.petsGoFree,
          reviewsAnalysis: JSON.parse(data.reviewsAnalysis),
        }
      });
    }
  });
});
